import React from 'react';
import './footer.css'; 
import { FaSpotify, FaYoutube } from "react-icons/fa";
import { RiInstagramFill } from "react-icons/ri";
import { IoMdMail } from "react-icons/io";
import { IoLogoWhatsapp } from "react-icons/io";

const Footer = () => {
  return ( 
  <footer className = 'footer'>
        <FooterInfos />
        <ContactInfos/>
  </footer>
  );
};


const FooterInfos = () => {
  return(
      <div>
          <h1 className='footer-title'>Parcerias e shows</h1>
          <address className='infos'>
            <IoMdMail /> lemathproducoes@gmail.com
          </address>   
          <a href="https://api.whatsapp.com/send?phone=5532999343877" className='infos' target="_blank" rel="noopener noreferrer">
             <IoLogoWhatsapp /> (32) 99934-3877
          </a>  
          <a href='https://www.instagram.com/lemath.producoes/' className='infos' target='_blank' rel="noreferrer">
            <RiInstagramFill /> lemath.producoes
          </a>
      </div>
  )
}


const ContactInfos = () => {
  return (
    <div>
      <h1 className='footer-title'>Acompanhe nosso trabalho!</h1>

      <a href='https://www.instagram.com/maracajudegaveta/' className='infos' target='_blank' rel="noreferrer"> <RiInstagramFill className= 'icon' /> Instagram</a>
      <a href='https://open.spotify.com/intl-pt/artist/3LtAa0gp7mQCPEcbyFs8nd?trackId=1CKfCj9izL24zGTrO6QTFE' className='infos' target='_blank' rel="noreferrer"><FaSpotify className= 'icon' />  Spotify</a>
      <a href='https://www.youtube.com/@Maracajudegaveta' className='infos' target='_blank' rel="noreferrer" ><FaYoutube className= 'icon'  /> YouTube</a>
      <p className='copyright'>
        © {new Date().getFullYear()} Todos os direitos reservados
      </p>

    </div>
  )
}




export default Footer;


